var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylNewsMobile',_vm._b({},'ylNewsMobile',_vm.$attrs,false)):_c('ylNewsPC',_vm._b({},'ylNewsPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }